export default __webpack_public_path__ + "static/sport-8405a50fef100e511518e116d10971f3.jpg";